import { CategoryBadge } from './CategoryBadge';
import { signedPercent } from './signedPercent';
import { PhoneList, PhoneListRow } from '../PhoneList';

/**
 * The equipment table on a phone: each item's name in full, its category and
 * one figure under it (the daily rate, say), and its ROI on the right.
 *
 * rows: [{ item, roi, roiStatus, detail }] - worked out once by the page,
 *       for this list and the table both.
 */
export function EquipmentPhoneList({ rows, onOpen, muted = false }) {
  return (
    <PhoneList data-testid="equipment-phone-list">
      {rows.map(({ item, roi, roiStatus, detail }) => (
        <PhoneListRow
          key={item.id}
          onClick={() => onOpen(item.id)}
          muted={muted}
          title={item.name}
          detail={
            <>
              <CategoryBadge category={item.category} className="text-xs px-1.5 py-0" />
              <span className="tabular-nums truncate">{detail}</span>
            </>
          }
          trailing={<span className={roiStatus.color}>{signedPercent(roi)}</span>}
          data-testid={`equipment-phone-row-${item.id}`}
        />
      ))}
    </PhoneList>
  );
}
